import { Account } from './Account/Account';
import { Confirm } from './Confirm/Confirm';
import { InsuranceInfo } from './Insurance/InsuranceInfo';
import { PatientInfo } from './Insurance/PatientInfo';
import { OngoingCareQuestion } from './OngoingCareQuestion/OngoingCareQuestion';
import { PhoneNumber } from './PhoneNumber/PhoneNumber';
import { TreatmentsQuestion } from './TreatmentsQuestion/TreatmentsQuestion';
import { StepId } from './types';
import { Verify } from './Verify/Verify';

// Map step IDs to components to avoid circular dependencies
export const stepComponents = Object.freeze({
  [StepId.ACCOUNT]: Account,
  [StepId.PHONE_NUMBER]: PhoneNumber,
  [StepId.ONGOING_CARE]: OngoingCareQuestion,
  [StepId.TREATMENTS]: TreatmentsQuestion,
  [StepId.PATIENT_INFO]: PatientInfo,
  [StepId.INSURANCE]: InsuranceInfo,
  [StepId.VERIFY]: Verify,
  [StepId.CONFIRM]: Confirm,
} as const);
